export const  calculateDateDifference = (baseDate: Date, daysToAdd: number): string => {
    return new Date(new Date(baseDate).setDate(baseDate.getDate() + daysToAdd)).toISOString().split("T")[0];
}